// extracted by mini-css-extract-plugin
export default {"root":"IconHamburgerMenuFilled_root__3_i_a"};